import type { Fallacy } from "./types";
import { createStory } from "./types";

export const meanVsMedian: Fallacy = {
    id: "mean-vs-median",
    name: "Mean vs Median Trick",
    emoji: "📉",
    category: "Manipulasi Statistik",
    description: "Menggunakan **rata-rata (mean)** padahal **median lebih representatif**, terutama saat data timpang.",
    tldr: "\"Rata-rata gaji karyawan 15jt!\" — karena bos gajinya 200jt.",
    detail: "Mean vs Median Trick terjadi ketika seseorang sengaja **memilih ukuran statistik** yang paling **menguntungkan narasinya**, padahal ukuran lain lebih jujur menggambarkan realita.\n\nMean sangat sensitif terhadap outlier. Dalam perusahaan dengan 9 karyawan bergaji Rp5 juta dan 1 direktur bergaji Rp200 juta, rata-rata gaji Rp24.5 juta — angka yang tidak dialami siapa pun. Median-nya? Rp5 juta, jauh lebih representatif.\n\nMean menipu saat **distribusi data tidak simetris** (skewed) — ada nilai yang jauh lebih besar atau kecil dari mayoritas. Dalam situasi ini, median jauh lebih representatif.\n\nCara mengenali: Setiap kali melihat klaim \"rata-rata\", tanyakan: \"Apakah ada outlier? Berapa median-nya?\"",
    story: createStory("Mean vs Median Trick", "📉", {
      hook: {
        title: "\"Rata-rata gaji kita 15 juta!\"",
        body: "Kedengeran keren... sampai kamu tau bos gajinya 200 juta dan yang lain cuma 5 juta.",
      },
      convo: {
        claim: "Keren sih perusahaan kita, **rata-rata gaji karyawan 18 juta** per bulan. Bukti kita sejahtera.",
        response: "Bos gajinya 200 juta, yang lain 5 juta. **Median-nya cuma 5 juta, bukan 18 juta.**",
      },
      reveal: {
        body: "Rata-rata (mean) gampang **ditarik oleh angka ekstrem**. Satu outlier bisa bikin angka rata-rata jauh dari kenyataan mayoritas.",
      },
      insight: {
        title: "Kapan mean menipu?",
        body: "Saat ada satu orang yang gajinya **jauh lebih gede** dari semua orang. Satu outlier bisa bikin rata-rata naik drastis, padahal mayoritas gak ngerasain.",
      },
      engagement: {
        title: "Pernah nemu \"rata-rata\" yang gak masuk akal? 📉",
        body: "Gaji perusahaan atau statistik pemerintah? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["misleading-statistics", "cherry-picking", "ecological-fallacy"],
  };
